import React from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import Wrapper from "../components/Wrapper";
import Sidebar from "../components/Sidebar";
import Main from "../components/Main";
import Navbar from "../components/Navbar";
import Content from "../components/Content";
import Footer from "../components/Footer";
import ErrorBoundary from "../components/ErrorBoundary";

const Dashboard = ({ sidebar, children }) => {
  const location = useLocation();

  return (
    <React.Fragment>
      <Wrapper>
        {!sidebar.isOnRight && <Sidebar />}
        <Main>
          <Navbar />
          <Content>
            <ErrorBoundary key={location.pathname}>{children}</ErrorBoundary>
          </Content>
          <Footer />
        </Main>
        {sidebar.isOnRight && <Sidebar />}
      </Wrapper>
    </React.Fragment>
  );
};

export default connect((store) => ({
  sidebar: store.sidebar,
}))(Dashboard);
